import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { Image } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const ImgNode = memo(({ id, data, isConnectable, selected }) => {
  const url = data?.url;
  const imgSrc = url
    ? url.startsWith("http")
      ? url
      : `${process.env.REACT_APP_BACKEND_URL}/public/${url}`
    : null;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Image />}
      title="Imagem"
      color="#22c55e"
      bgColor="#F0FFF4"
      isConnectable={isConnectable}
      selected={selected}
    >
      {imgSrc ? (
        <div
          style={{
            borderRadius: 6,
            overflow: "hidden",
            border: "1px solid #e0e0e0",
            marginTop: 2,
          }}
        >
          <img
            src={imgSrc}
            alt="preview"
            style={{
              maxHeight: 80,
              maxWidth: 180,
              objectFit: "cover",
              display: "block",
              borderRadius: 6,
            }}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </div>
      ) : (
        <div
          style={{
            fontSize: 11,
            color: "#999",
            fontStyle: "italic",
            padding: "8px 0",
          }}
        >
          Enviar imagem
        </div>
      )}
    </NodeWrapper>
  );
});

ImgNode.displayName = "ImgNode";
export default ImgNode;
